<template>
  <div>
    <div class="flex flex-col items-start text-white m-4">
      <div class="font-bold text-xl">Olvide mi contraseña</div>
      <div class="content-start text-left text-teal-200 text-sm mt-2">Se enviará un correo electrónico a tu casilla de email con un código de seguridad</div>
      <div class="mt-4">Correo electrónico:</div>
      <div class="w-full"><input type="text" id="email" v-model="email" class="text-gray-800 p-1 w-full" /></div>
      <div class="text-yellow-500">{{ mensaje }}</div>
      <div>
        <button @click="enviar" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">
          Enviar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      email: ""
    };
  },
  mounted() {
    this.$store.dispatch("iniciarRecuperacionContrasena");
  },
  methods: {
    enviar() {
      this.$store.dispatch("enviarMailRecuperacionContrasena", {
        email: this.email,
        apiToken: process.env.VUE_APP_API_TOKEN
      });
    }
  },
  computed: {
    ...mapState({
      mensaje: state => state.olvideMiContrasena.mensajeErrorEmail
    })
  }
};
</script>
